import $ from "jquery"
import Chat from "../../components/chat/chat"
// import DynamicExternalModuleLoader from "./DynamicExternalModuleLoader"

const Config = {
	debug: false,
	version: version,
	env: env,
	proxy: "",
	publicPath: "typo3conf/ext/bb_themepackage_os/Resources/",
	documentRoot: "/",
	faq: {
		searchMinChar: 3,
		highlightClass: "search-hit",
	},
	module: {
		external: [
			{
				selector: ".bb-iframe-resizer",
				css: [],
				js: [
					{
						url: "typo3conf/ext/bb_iframe/Resources/Public/Scripts/iframeResizer.min.js",
						crossDomain: false,
						loadedCallback: () => {
							window.iFrameResize({ log: false, checkOrigin: false })
						},
					},
				],
			},
			{
				selector: ".bb-chat",
				css: [],
				js: [
					{
						url: "https://static2000.multichannelacd.de/chat/v1/product/acdacd2039/js/4com.lsm.starter-api.min.js",
						crossDomain: true,
						loadedCallback: () => {
							new Chat()
						},
					},
				],
			},
		],
	},
	jobsuche: {
		resultPerPage: 12,
		bbJobsAutoCompleteApi: {
			dev: "",
			live: "?api=bbbjobs_autocomplete&wordStartsWith={%CHAR%}&amount=12",
		},
		pagination: {
			numberPrevItems: 2,
			numberNextItems: 2,
		},
	},
	medienportal: {
		resultPerPage: 10,
		pagination: {
			numberPrevItems: 2,
			numberNextItems: 2,
		},
	},
	chatOptions: {
		tooltipCookieName: "os-cookie-chat-tooltip",
		entranceId: "373a0226-d35a-469e-bee2-d7cd9153e112", // PROD
		//entranceId: "5cce6e5d-54bd-4b96-b17c-e2de26c47781", // DEV
		acdLabel: "acd2039",
		chatServiceUrl: "https://api2000.multichannelacd.de/",
		configServiceUrl: "https://data2000.multichannelacd.de/",
		staticContentUrl: "https://static2000.multichannelacd.de/",
	},

	// cookieWarning: {
	// 	name: "bb-cookie-warning-accepted",
	// 	expires: 365,
	// },
	// banner: {
	// 	name: "bb-banner-clicked",
	// 	expires: 30,
	// },
	search_autocomplete_api: {
		dev: "",
		live: "?eID=keSearchPremiumAutoComplete",
	},
	search_recommendation_api: {
		dev: "",
		live: "?type=847857858&tx_kesearch_pi1%5Bsword%5D=",
	},
	search_recommendation_most_searched_api: {
		dev: "",
		live: "?actionResponse=searchword_statistic&storage_pid=23&days=30&no_cache=1",
	},
	// searchContactPerson: {
	// 	api: {
	// 		dev: "https://swk.dev.bippesbrandao.net/ansprechpartner-ajax/contacts?plz=",
	// 		live: "ansprechpartner-ajax/contacts?plz=",
	// 	},
	// },
}

export default $.extend(true, Config, window.bbConfig)
